function numberToWord(number) {
  const values = ['', 'one', 'two', 'three', 'four']

  return values[number] || ''
}

export default numberToWord
